import classNames from "classnames";
// import "./balances-dropdown.css";
import { useEffect, useRef, useState } from "react";
import { useWebgate } from "@xvia/webgate-connect";
import { NotaPiauienseService } from "../../service/NotaPiauiense";
import { ApiResponse } from "../../service/models";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatCurrency } from "../../utils/formatCurrency";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./balances.css";
import { BalancesDropdown } from "./components/BalancesDropdown";

export function Balances() {
  const [isBalancesDropdownOpen, setIsBalancesDropdownOpen] = useState(false);
  const balanceRef = useRef<HTMLDivElement>(null);
  const [notaPiauiense, setNotaPiauiense] = useState<ApiResponse | null>(null);
  const { accessToken } = useWebgate();

  const handleCloseBalancesDropdown = () => {
    setIsBalancesDropdownOpen(false);
  };

  const handleBalanceClick = (e: React.MouseEvent) => {
    setIsBalancesDropdownOpen(!isBalancesDropdownOpen);
  };

  const handleBalanceKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setIsBalancesDropdownOpen(!isBalancesDropdownOpen);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        balanceRef.current &&
        !balanceRef.current.contains(event.target as Node)
      ) {
        setIsBalancesDropdownOpen(false);
      }
    };

    if (isBalancesDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isBalancesDropdownOpen]);

  useEffect(() => {
    if (accessToken) {
      NotaPiauienseService.listNotas(accessToken).then((response) => {
        setNotaPiauiense(response);
      });
    }
  }, [accessToken]);

  return (
    <div
      className="balance-container"
      style={{ position: "relative" }}
      ref={balanceRef}
    >
      {accessToken && (
        <div
          role="button"
          tabIndex={0}
          className="balance"
          onClick={handleBalanceClick}
          onKeyDown={handleBalanceKeyDown}
          aria-label="Nota Piauiense, abrir dropdown de saldo da Nota Piauiense"
        >
          <span className="balance__label">Nota Piauiense</span>
          <span className="balance__value">
            {formatCurrency(notaPiauiense?.data?.saldoNotaPovo?.saldoLiberado)}
          </span>
          <FontAwesomeIcon
            icon={faChevronDown}
            color="#fff"
            className={classNames("balance__icon", {
              "balance__icon--rotated": isBalancesDropdownOpen,
            })}
          />
        </div>
      )}

      <BalancesDropdown
        isOpen={isBalancesDropdownOpen}
        onClose={handleCloseBalancesDropdown}
        notaPiauiense={notaPiauiense}
      />
    </div>
  );
}
